import React, {useEffect, useState} from 'react';
import MainPageTitle from '../../designComponents/titles/MainPageTitle';

import SendPush, {PushAlarmTypes, PushPlatformTypes} from '../../EventComponents/PushAlarm/SendPush';
import FlexMainWrapper, {Wrapper02} from '../../designComponents/wrappers/FlexMainWrapper';
import AppTab from '../../GroupComponent/Tab/AppTab';
import UserDeviceTable from '../../EventComponents/PushAlarm/UserDeviceTable';
import Form from 'react-bootstrap/Form';
import {MText} from '../../designComponents/text/ContentText';
import UserIdInputTable from '../../EventComponents/PushAlarm/UserIdInputTable';

const PushAlarm = () => {
    const [platform, setPlatform] = useState(PushPlatformTypes.SIRUP);

    const [userIdList, setUserIdList] = useState([]);

    const [type, setType] = useState(PushAlarmTypes.USER);

    useEffect(() => {
        setType(0);
        setUserIdList([]);
    }, [platform]);
    useEffect(() => {
        if (type !== PushAlarmTypes.USER) {
            setUserIdList([]);
        }
    }, [type]);

    return (
        <Wrapper02 style={{ marginBottom: '20px' }}>
            <MainPageTitle text={'푸시 알람'} />
            <AppTab platform={platform} setPlatform={setPlatform} />

            <SendPush platform={platform} userIdList={userIdList} type={type} />
            <TypeSelector type={type} setType={setType} />
            {type === PushAlarmTypes.USER && <UserDeviceTable setSendUser={setUserIdList} platform={platform} />}
            {(type === PushAlarmTypes.ID || type === PushAlarmTypes.PHONE) && <UserIdInputTable setSendUser={setUserIdList} isPhone={type === PushAlarmTypes.PHONE} />}
        </Wrapper02>
    );
};
const TypeSelector = ({ type, setType }) => {
    return (
        <div>
            <MText>전송 대상 선택</MText>
            <Form>
                <FlexMainWrapper>
                    <Form.Check inline label="특정 회원" name="group1" type={'radio'} checked={type === PushAlarmTypes.USER} onClick={() => setType(PushAlarmTypes.USER)} />
                    <Form.Check inline label="전체 회원(알림 동의자)" name="group1" type={'radio'} checked={type === PushAlarmTypes.ALARM} onClick={() => setType(PushAlarmTypes.ALARM)} />
                    <Form.Check inline label="마케팅 동의자(광고)" name="group1" type={'radio'} checked={type === PushAlarmTypes.MARKETING} onClick={() => setType(PushAlarmTypes.MARKETING)} />
                    <Form.Check inline label="ID 입력" name="group1" type={'radio'} checked={type === PushAlarmTypes.ID} onClick={() => setType(PushAlarmTypes.ID)} />
                    <Form.Check inline label="전화번호 입력" name="group1" type={'radio'} checked={type === PushAlarmTypes.PHONE} onClick={() => setType(PushAlarmTypes.PHONE)} />
                </FlexMainWrapper>
            </Form>
        </div>
    );
};
export default PushAlarm;
